import React, { useState, useEffect, memo } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import SortIcon from '@material-ui/icons/Sort'
import { withToursSectionStoreValue, ToursSectionStoreDispatchAction, EToursSectionStateActionTypes } from '../store';

enum BottomBarOptionsEnum {
    Grid,
    Map,
    Categories,
    Sort
}

interface IBottomBarToursStoreProps {
    dispatch: ToursSectionStoreDispatchAction
    showMap: boolean
    showCategories: boolean
    showSortMenu: boolean
}

const BottomBarCore = memo((props: IBottomBarToursStoreProps) => {
    console.log("Render BottomBar")
    const { t } = useTranslation()
    const [activeOption, setActiveOption] = useState(BottomBarOptionsEnum.Grid)

    const { showMap, showCategories, showSortMenu, dispatch } = props

    useEffect(() => {
        if (!showCategories && activeOption === BottomBarOptionsEnum.Categories || !showSortMenu && activeOption === BottomBarOptionsEnum.Sort) {
            setActiveOption(showMap ? BottomBarOptionsEnum.Map : BottomBarOptionsEnum.Grid)
        }
    }, [showCategories, showSortMenu])

    const sortHandle = () => {
        setActiveOption(BottomBarOptionsEnum.Sort)
        dispatch({ type: EToursSectionStateActionTypes.SetShowSortMenu, showSortMenu: true })
        dispatch({ type: EToursSectionStateActionTypes.SetShowMap, showMap: false })
        dispatch({ type: EToursSectionStateActionTypes.SetShowCategories, showCategories: false })
    }

    const gridHandle = () => {
        setActiveOption(BottomBarOptionsEnum.Grid)
        dispatch({ type: EToursSectionStateActionTypes.SetShowSortMenu, showSortMenu: false })
        dispatch({ type: EToursSectionStateActionTypes.SetShowMap, showMap: false })
        dispatch({ type: EToursSectionStateActionTypes.SetShowCategories, showCategories: false })
    }

    const mapHandle = () => {
        setActiveOption(BottomBarOptionsEnum.Map)
        dispatch({ type: EToursSectionStateActionTypes.SetShowSortMenu, showSortMenu: true })
        dispatch({ type: EToursSectionStateActionTypes.SetShowMap, showMap: true })
        dispatch({ type: EToursSectionStateActionTypes.SetShowCategories, showCategories: false })
    }

    const categoryHandle = () => {
        setActiveOption(BottomBarOptionsEnum.Categories)
        dispatch({ type: EToursSectionStateActionTypes.SetShowSortMenu, showSortMenu: false })
        dispatch({ type: EToursSectionStateActionTypes.SetShowCategories, showCategories: true })
    }

    return (
        <>
            <div className="tours-bottom-bar">
                <a className="home" href='/'>
                    <img src="/images/logo/logo.jpg" alt="360 Tourist" />
                </a>
                <button className={classNames('grid', { active: activeOption === BottomBarOptionsEnum.Grid })} onClick={gridHandle} >
                    {t('Grid')}
                </button>
                <button className={classNames('map', { active: activeOption === BottomBarOptionsEnum.Map })} onClick={mapHandle}>
                    {t('Map')}
                </button>
                <button className={classNames('category', { active: activeOption === BottomBarOptionsEnum.Categories })} onClick={categoryHandle}>
                    {t('Category')}
                </button>
                <button className={classNames('sort', { active: activeOption === BottomBarOptionsEnum.Sort })} onClick={sortHandle} >
                    <SortIcon />
                    {t('Sort')}
                </button>
                {/* <button className="location">
                    {t('Location')}
                </button> */}
            </div>
        </>
    )
})

export const BottomBar = withToursSectionStoreValue<IBottomBarToursStoreProps>(BottomBarCore, ['dispatch', 'showCategories', 'showMap', 'showSortMenu'])